import React, { useEffect, useState } from "react";
import YuniteTournamentService from "../../../../services/YuniteTournamentService";
import YunitePlayer from "../../../UiLibrary/YunitePlayer";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingPlaceholders from "../../../UiLibrary/LoadingPlaceholders/LoadingPlaceholders";

const YuniteMatchLeaderboard = (props) => {
  const { tournament, matchId, guildId } = props;
  const [matchSession, setMatchSession] = useState([]);
  const [paginatedItems, setPaginatedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    if (matchId) {
    setLoading(true);
    const id = tournament?.yuniteId ? tournament?.yuniteId : tournament?.id;
    YuniteTournamentService.getCacheMatch(id, matchId, guildId)
      .then((response) => {
        setMatchSession(response);
        const index = response.length >= 20 ? 20 : response.length;
        let items = [];
        for (let i = 0; i < index; i++) {
          items.push(response[i]);
        }
        setPaginatedItems(items);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
      });
    }
  }, [matchId, tournament]);

  const fetchMoreData = () => {
    setTimeout(() => {
      setPaginatedItems([
        ...paginatedItems,
        matchSession[paginatedItems.length],
      ]);
    }, 100);
  };

  return (
    <>
      <div className="container">
        <div className="columns">
          <div className="column col-12">
            <div className="container">
              <div className="columns skp-text-light m-2">
                <div className="column col-1 flex-centered">#</div>
                <div className="column col-9 col-xs-10">Team</div>
                <div className="column col-1 flex-centered hide-xs">Kills</div>
                <div className="column col-1 flex-centered">Score</div>
              </div>

              {!loading && (error || paginatedItems.length === 0) && (
                <div className="container">
                  <div className="columns skp-text-light text-center">
                    <div className="space-divider"></div>
                    <div className="column col-12">
                      <h1>
                        <i className="las la-trophy"></i>
                      </h1>
                    </div>
                    <div className="column col-12">
                      <h5>No Results</h5>
                    </div>
                    <div className="column col-12">
                      The leaderboard is empty
                    </div>
                  </div>
                </div>
              )}
              {loading && (
                <LoadingPlaceholders numberOfItems={10}>
                  <div className="skp-table-flex-row skp-table-flex-row-loading"></div>
                </LoadingPlaceholders>
              )}

              {!loading && (
                <InfiniteScroll
                  dataLength={paginatedItems.length}
                  scrollableTarget="skpModalOverlay"
                  next={fetchMoreData}
                  hasMore={matchSession.length > paginatedItems.length}
                  style={{ overflow: "hidden" }}
                  loader={
                    <div>
                      <div className="loading"></div>
                    </div>
                  }
                  scrollThreshold={"300px"}
                  endMessage={
                    <>
                      {paginatedItems.length >= 20 && (
                        <>
                          <p
                            className="text-center skp-text-light m-2"
                            style={{ textAlign: "center" }}
                          >
                            END
                          </p>
                        </>
                      )}
                    </>
                  }
                >
                  {paginatedItems &&
                    paginatedItems.map((row, index) => (
                      <div
                        className="columns skp-text-primary m-2 bordered-list pt-2"
                        key={`row-${index}`}
                      >
                        <div className="column col-1 flex-centered">
                          {row?.placement}
                        </div>
                        <div className="column col-9 col-xs-10">
                          <div className="columns">
                            {row?.team &&
                              row?.team?.players.map((user, idx) => (
                                <div key={idx}
                                  className={`column col-${
                                    12 / row?.team?.players.length
                                  }`}
                                >
                                  <YunitePlayer player={user} tournament={tournament}/>
                                </div>
                              ))}
                          </div>
                        </div>
                        <div className="column col-1 flex-centered hide-xs">
                          {row?.kills}
                        </div>
                        <div className="column col-1 flex-centered">
                          {row?.score}
                        </div>
                      </div>
                    ))}
                </InfiniteScroll>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YuniteMatchLeaderboard;
